import { colorFactory } from "../color-factory";

const blackColor = colorFactory({ hue: 0, saturation: 0, light: 0 });

export { blackColor };
